import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './FAQSection.css';

const FAQSection = ({ title, faqs, defaultActiveKeyProp }) => {
  const [activeKey, setActiveKey] = useState(defaultActiveKeyProp || null);

  const toggleFaq = (index) => {
    setActiveKey(activeKey === index ? null : index);
  };

  return (
    <section className="faq-section">
      <Container>
        <h2 className="section-title">{title}</h2>
        
        <div className="faq-container">
          <div className="custom-accordion">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <div 
                  className={`faq-question ${activeKey === index ? 'active' : ''}`}
                  onClick={() => toggleFaq(index)}
                  style={{ cursor: 'pointer' }}
                >
                  {faq.question}
                  <span className="faq-toggle">{activeKey === index ? '−' : '+'}</span>
                </div>
                {activeKey === index && (
                  <div className="faq-answer">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FAQSection;
